/** Namespace `acquisitionOps` — PLAT-2026-173: màn « Máy chủ lấy hóa đơn VN » (chỉ đọc). */
export const acquisitionOps = {
  title: "Máy chủ lấy hóa đơn Việt Nam",
  subtitle: "Tình trạng collector lấy hóa đơn từ cổng thuế: hàng chờ, lỗi, thông số chạy. Chỉ đọc, tính khi bạn mở trang hoặc bấm Làm mới (không tự cập nhật, không thêm tải).",
  refresh: "Làm mới",
  loadFailed: "Không đọc được tình trạng từ bube-einvoice.",
  notConfigured: "bube-einvoice chưa nối collector lấy hóa đơn (chưa cấu hình).",
  unavailable: "Collector không trả lời lúc này. Dữ liệu cũ không được hiển thị để tránh sai lệch.",
  generatedAt: "Chụp lúc {time} (đệm tối đa 30 giây)",
  secRunner: "Trạng thái chạy",
  runnerOn: "Đang bật",
  runnerOff: "Đang tắt",
  restored: "Đã đồng bộ sau khôi phục",
  notRestored: "Chưa đồng bộ sau khôi phục — runner phải tắt",
  accounts: "Số tài khoản chạy đồng thời: {n}",
  interval: "Giãn cách tối thiểu giữa hai request: {n} ms",
  slice: "Một lát chạy: tối đa {ms} ms · {invoices} hóa đơn · {requests} request",
  secCooldown: "Cổng thuế giới hạn (429)",
  cooldownOn: "Đang nghỉ tới {time}",
  cooldownOff: "Không nghỉ",
  secQueue: "Hàng chờ",
  due: "Đến hạn chạy: {n}",
  delayed: "Chờ giờ thử lại: {n}",
  oldest: "Job đến hạn lâu nhất đã chờ: {n} giây",
  itemsWaiting: "Hóa đơn đang chờ tải / chờ xác nhận: {queued} / {ack}",
  jobsByState: "Job theo trạng thái",
  secErrors: "Lỗi 24 giờ qua",
  noErrors: "Không có lỗi.",
  colCode: "Mã lỗi",
  colCount: "Số lần",
  secHttp: "Request tới cổng thuế (24 giờ)",
  requests: "Tổng request: {n}",
  rateLimited: "Bị giới hạn 429: {n}",
  serverErrors: "Lỗi máy chủ cổng thuế 5xx: {n}",
  clientErrors: "Lỗi 4xx khác: {n}",
  latency: "Độ trễ trung bình: {n} ms",
  secSlices: "Thông số mỗi lượt chạy (24 giờ)",
  sliceCount: "Số lát chạy: {n}",
  sliceAvg: "Request trung bình mỗi lát: {n}",
  sliceInvoices: "Hóa đơn đã xét: {n}",
  sliceRss: "RAM cao nhất: {n} MB",
  logins: "Đăng nhập: {ok}/{n} thành công · giải captcha {c} lần",
  secSpool: "Hàng đợi kết quả (spool)",
  spoolLine: "Chờ gửi: {ready} · đang giữ chỗ: {reserved} · {used} / {limit} MB",
  secLedger: "Sổ đã tải (không tải lại)",
  ledgerLine: "{key}: {n}",
  secCaptcha: "Chi phí captcha (24 giờ)",
  noCaptcha: "Không phát sinh.",
  secConnections: "Kết nối",
  secJobs: "Job gần đây",
  secEvents: "Nhật ký lỗi / thử lại / kết thúc (30 ngày gần nhất)",
  colWhen: "Lúc",
  colKind: "Loại",
  colState: "Trạng thái",
  colAttempt: "Lần",
  colRetry: "Thử lại sau",
  colJob: "Job",
  colStage: "Giai đoạn",
  colUpdated: "Cập nhật",
  noEvents: "Chưa có sự kiện.",
} as const;
